import React, { useState } from "react";
import "../../style/Sortable.css";

function Sortable() {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <div className="sortable-container col-md-8 col-lg-8 col-xl-8">

      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Sortable
      </h1>

      {/* Tabs */}
      <div className="nav nav-tabs">
        <button
          className={`nav-link ${activeTab === "list" ? "active" : ""}`}
          onClick={() => setActiveTab("list")}
        >
          List
        </button>

        <button
          className={`nav-link ${activeTab === "grid" ? "active" : ""}`}
          onClick={() => setActiveTab("grid")}
        >
          Grid
        </button>
      </div>

      {/* Tab Content */}

      {activeTab === "list" && (
        <div className="tab-content">

          <table className="table sortable-table">
            <thead>
              <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Username</th>
              </tr>
            </thead>

            <tbody>

              <tr draggable>
                <td>↕ 1</td>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
              </tr>

              <tr draggable>
                <td>↕ 2</td>
                <td>Jacob</td>
                <td>Thornton</td>
                <td>@fat</td>
              </tr>

              <tr draggable>
                <td>↕ 3</td>
                <td colSpan="2">Larry the Bird</td>
                <td>@twitter</td>
              </tr>

            </tbody>
          </table>

        </div>
      )}

      {activeTab === "grid" && (
        <div className="grid-container">

          {[1,2,3,4,5,6].map((item)=>(
            <div key={item} className="grid-card" draggable>

              <h3>Thumbnail label {item}</h3>

              <p>
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Donec id elit non mi porta gravida at eget metus.
              </p>

              <div className="grid-buttons">
                <button className="btn btn-primary">Button</button>
                <button className="btn btn-secondary">Button</button>
              </div>

            </div>
          ))}

        </div>
      )}

    </div>
  );
}

export default Sortable;